import { H1 } from "@quarks";
import { truncateString } from "@utils";
import styled from "styled-components";

export const StyledRoomName = styled(H1)`
  ${truncateString};
`;
